import { atom } from 'recoil'

import { DEFAULT_URL_CONTEXT } from '../../utils/url-utils'
import { UrlContext } from './types'

export const $urlContext = atom<UrlContext>({
  key: 'UrlContext',
  default: DEFAULT_URL_CONTEXT,
})
